<section>
    <div class="container">
        <div class="login-section card mx-auto p-5">
            <div class="header w-100 text-center mb-4">
                <img src="assets/Bergh-Bouwgroep-logo.png" height="64">
            </div>
            <div class="title">
                <h6 class="mb-4 bergh-text-primary text-center">{{lang.forgotPassword.title}}</h6>
            </div>
            <form [formGroup]="forgotPasswordForm" (ngSubmit)="forgotPasswordFormSubmit()" id="forgotPasswordForm">
                <div class="form-group">
                    <label for="emailInput">{{lang.forgotPassword.emailLabel}}</label>
                    <input type="email"
                           [ngClass]="{'form-control':true,'is-invalid':forgotPasswordForm.controls['email'].invalid && forgotPasswordForm.controls['email'].touched}"
                           id="emailInput"
                           formControlName="email"
                           placeholder="{{lang.forgotPassword.emailPlaceholder}}">
                    <div class="invalid-feedback" id="emailError">Invalid email</div>
                </div>
                <div class="form-group mt-5">
                    <button class="btn bergh-bg-secondary text-white w-100" type="submit" id="submitBtn" [disabled]="forgotPasswordForm.invalid">{{lang.forgotPassword.forgotPasswordBtn}}</button>
                </div>
                <div class="footer text-center mt-4">
                    <a routerLink="/login" class="bergh-text-secondary" id="backToLoginLink">{{lang.forgotPassword.backToLogin}}</a>
                </div>
            </form>
        </div>
    </div>
</section>
